/**
 * @format
 */
/* eslint-disable @typescript-eslint/no-var-requires*/
const contrastPlaceholderAddBtn = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/115616/8/17167/465/5f55dfc1E46ddb768/00eb2f7d5efef573.png',
};
const contrastCurrentIcon = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/143722/14/7845/652/5f55dfcfEb8be0bc7/c7aefaa201e610fa.png',
};
const contrastBtnShadow = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/121278/20/11912/2148/5f55dfcfE4be87ee3/74edb9c0ffebf6e0.png',
};
const contrastGoodsArrow = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/149803/36/7831/453/5f55dfa1E00a1446a/4fcdbc4e4564f441.png',
};
const contrastCurrentViewIcon = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/115973/40/17140/400/5f55dfa0E97cc3d74/001b0b9e28a0b34c.png',
};
const contrastVsIcon = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/113286/22/17105/6254/5f55dfaeE445321bb/ff5d60ff964dcea6.png',
};
const contrastDialogClose = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/130648/19/9344/824/5f55dfa1Ed3c38aef/e5c355d7a563e9f6.png',
};
const contrastGoodsShadow = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/120518/38/11871/2633/5f55dfa1E7852c37e/0f456f5938f89135.png',
};
const contrastPriceArrowRight = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/135718/35/9426/395/5f55dfa1Edfa46a22/be6cf14f8508d995.png',
};
const contrastMedalIcon = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/151264/10/82/1593/5f55dfa1E6c0704bf/15cccd5eeb38a8e6.png',
};
const contrastMoreComment = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/146413/34/7816/344/5f55dfa1Ef23f0641/be87c168483303fc.png',
};
const contrastTicketReceived = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/130422/12/9318/5193/5f55dfa1E0498acc4/81cf2cc096fe2374.png',
};
const addContrastSoldOutNoGoods = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/115856/40/17288/6291/5f55df4dEc0707688/68980b3e5618ae19.png',
};
const addContrastRemoveShelves = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/128623/32/12085/6652/5f55df4dEfcc44f5c/8e9e863822dbd59a.png',
};
const addContrastTicketShadow = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/133735/2/9336/2000/5f55df4dEcf6ed7ff/1162cbd5f800fb98.png',
};
const selectCurrentViewIcon = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/126989/40/11822/242/5f55df63Eb15b9559/ccb7860b179c4fdc.png',
};
const commonDelete = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/120189/6/12017/848/5f55df63E0e21cc59/cd3db4f64c7f802a.png',
};
const commonPlaceholder = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/147190/32/6807/26350/5f4636b4Ec337b28b/24091b5fdd32f0e0.png',
};
const commonRadioBg = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/130759/14/9356/1966/5f55df63E5fbd4165/3b219f9a923fe578.png',
};
const commonRadioChecked = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/143202/30/7655/3740/5f55df63E3d05c957/8877d65143daeab3.png',
};
const commonRadioHasChecked = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/143133/4/7784/1818/5f55df63E372f4932/d47c45e2f4ffea71.png',
};
const commonRadioDisabled = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/145860/35/7883/1911/5f55df63E083a7bc4/7b21fc3e0145777c.png',
};
const commonBack = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/134388/32/9370/457/5f55df63E9a704654/6833c3197c45f207.png',
};
const commonShare = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/124323/40/11890/1257/5f55df63E6edd132e/52ce941ab9fa9a9e.png',
};
const commonCheckCategory = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/131153/31/9262/619/5f55df63Ecc04ac2d/9de795ddc021ce78.png',
};
const commonSelectCategoryArrowUp = {
  uri: 'https://m.360buyimg.com/imagetools/jfs/t1/134811/23/9302/468/5f55df63Eaf4cbc5c/262a1bba1c3eacff.png',
};

export default {
  common: {
    placeholder: commonPlaceholder,
    radioBg: commonRadioBg,
    radioCheck: commonRadioChecked,
    radioDisabled: commonRadioDisabled,
    radioHasChecked: commonRadioHasChecked,
    deleteBtn: commonDelete,
    back: commonBack,
    share: commonShare,
    checkCategory: commonCheckCategory,
    SelectCategoryArrowUp: commonSelectCategoryArrowUp,
  },
  contrast: {
    placeholderBtn: contrastPlaceholderAddBtn,
    curIcon: contrastCurrentIcon,
    BtnShadow: contrastBtnShadow,
    goodsJumpArrow: contrastGoodsArrow,
    currentViewIcon: contrastCurrentViewIcon,
    vsIcon: contrastVsIcon,
    dialogClose: contrastDialogClose,
    goodsShadow: contrastGoodsShadow,
    priceArrow: contrastPriceArrowRight,
    medalIcon: contrastMedalIcon,
    moreComments: contrastMoreComment,
    ticketReceived: contrastTicketReceived,
  },
  addContrast: {
    soldOutNoGoods: addContrastSoldOutNoGoods,
    removeShelves: addContrastRemoveShelves,
    ticketShadow: addContrastTicketShadow,
  },
  selectContrastGoods: {
    currentViewIcon: selectCurrentViewIcon,
  },
};
